import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { QUERY_TYPES } from "../../utils/queryBuilder";

const QueryTypeToggle = ({ value, onChange, queryTypes = QUERY_TYPES }) => (
  <ToggleButtonGroup
    exclusive
    fullWidth
    size="small"
    value={value}
    onChange={(_, next) => {
      if (next) onChange(next);
    }}
    sx={{
      bgcolor: "background.paper",
      "& .MuiToggleButton-root": {
        borderColor: "divider",
        color: "text.secondary",
        fontWeight: 700,
        textTransform: "none",
        px: 1.25,
        lineHeight: 1.2,
      },
      "& .Mui-selected": {
        color: "primary.contrastText",
        bgcolor: "primary.main",
        "&:hover": {
          bgcolor: "primary.dark",
        },
      },
    }}
  >
    {queryTypes.map((type) => (
      <ToggleButton key={type.value} value={type.value}>
        {type.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default QueryTypeToggle;
